import React, { useEffect, useState } from 'react';
import { Card } from 'reactstrap';
import { PieChartComponent } from './PieChartComponent';
import { buildHTMLFiltersSubtitle } from './utils';

interface IQuestionMoodContainerProps {
  values: any[]
  avidLabel: string
  surveyLabel: string
  periodLabel: string
  segmentName: string
  segmentCategory: string
  segment: string
  question: string
  commentType: string
  customerName: string
}

export function QuestionMoodContainer(props: IQuestionMoodContainerProps) {
  const [highchartsDataPoints, setHighchartsDataPoints] = useState([]);
  const {
    values,
    avidLabel,
    surveyLabel,
    periodLabel,
    segmentCategory,
    segment,
    customerName
  } = props

  const htmlSubtitle = buildHTMLFiltersSubtitle(
    avidLabel,
    surveyLabel,
    periodLabel,
    segment,
    segmentCategory,
  )

  useEffect(() => {
    let newDataPoints: any[];
    if (values) {
      newDataPoints = values.map((value, index) => {
        let color = '#e7e7e7';
        if (value.label === 'Suggestion') {
          color = '#FFAA00';
        }
        if (value.label === 'Compliment') {
          color = '#0493FC';
        }
        return {
          name: value.label,
          color,
          y: parseFloat(parseFloat(value.percent).toFixed(1)),
          surveyCount: value.surveyCount,
          count: Number(value.value),
          selected: index === 0
        }
      })
      setHighchartsDataPoints(newDataPoints)
    }
  }, [values])

  return (
    <Card>
      <span className="card-title" style={{ padding: '10px' }}>Customer Comments</span>
      {
        highchartsDataPoints &&
        <div className="card-content">
          <PieChartComponent
            title={''} //{`${customerName} Comments`}
            isLoading={false}
            legend={false}
            categories={[]}
            factor={'100'}
            chartHeight={350}
            seriesName={''}
            series={[]}
            avannisAvg={0}
            dataPoints={highchartsDataPoints}
            htmlSubtitle={htmlSubtitle}
            noDataMessage={'There is no data for the selected criteria.'}
          />
        </div>}
    </Card>
  );
}
